import styled, { keyframes, css } from "styled-components";
// const RombSVG = require("../../../assets/shape.svg");
import { ReactComponent as RombSVG } from "../../../svg/shape.svg";

// ANIMATIONS
const btnScale = keyframes`
  0% {
    transform: scale(1);
    animation-timing-function: cubic-bezier(0.33, 1, 0, 0);
  }
  33% {
    transform: scale(0.65);
    animation-timing-function: cubic-bezier(0.1, 0, 0, 1);
  }
  66% {
    transform: scale(1);
  }
`;
const btnBackground = keyframes`
 0% {
      opacity: 0;
      animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
    }
  33% {
      opacity: 0.5;
      animation-timing-function: cubic-bezier(0.2, 0.1, 0.3, 1);

      /* animation-timing-function: cubic-bezier(0.7, 0.2, 0.3, 0); */
    }
    66% {
      opacity: 0;
    }
`;

const btnScaleAnim = css`
  ${btnScale}
`;

const btnBackgroundAnim = css`
  ${btnBackground}
`;
//

const btnRotate = keyframes`
  0% {
    transform: rotate(-45deg);
    animation-timing-function: cubic-bezier(0.25, 0.2, 0.1, 0.9);
  }
  33% {
    transform: rotate(13.34deg);
    animation-timing-function: cubic-bezier(0.25, 1, 0.75, 0.1);
  }
  66% {
    transform: rotate(-10.65deg);
    animation-timing-function: cubic-bezier(0.25, 0, 0.75,1);
  }
  100% {
    transform: rotate(0deg);
  }
`;

const btnRotateAnim = css`
  ${btnRotate}
`;

const fadeInAnim = keyframes`
  0%{
     transform: translateY(75px);
     opacity:0
  }
  10%{
    transition-timing-function: cubic-bezier(0.42, 0, 0.07, 0.92);
    transform: translateY(75px);
    opacity:0
  }
  50%{
    transition-timing-function: cubic-bezier(0.29, 0.2, 0.62, 1);
    transform:translateY(-10px);
    opacity:0.5;
  }
  100%{
    transform:translateY(0px)
    opacity:1
   } 
`;

const fadeOutAnim = keyframes`
  0%{
    transition-timing-function: cubic-bezier(0.35, 0, 0.2, 1);
     transform: translateY(0);
     opacity:1;
    }
    100%{
      transform:translateY(123px);
      opacity:0;
   } 
`;

const fadeIn = css`
  ${fadeInAnim} 0.55s 1 forwards
`;
const fadeOut = css`
  ${fadeOutAnim} 0.55s 1 forwards
`;

export const OPContainer = styled.div`
  animation: ${fadeIn};
  animation: ${(p) => (p.unBlur ? fadeOut : null)};
  overflow-y: scroll;
  -ms-overflow-style: none; // IE 10+
  scrollbar-width: none; // Firefox
  &::-webkit-scrollbar {
    display: none; // Safari and Chrome
  }
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  font-size: 20px;

  color: #ffb000;
  background-color: #7f3da5bf;
  &&.prov {
    background-color: #7f3da5;
  }
  &&::-webkit-scrollbar {
    display: none;
  }
`;

export const OPBox = styled.div`
  scrollbar-width: none;

  /* padding: 30px; */
  max-width: 375px;
  max-height: 667px;
  overflow-y: scroll;
  overflow-x: hidden;

  margin: auto;
  position: relative;
  height: 100%;
  &&::-webkit-scrollbar {
    display: none;
  }
`;
export const OPHeader = styled.div`
  font-size: 20px;
  text-transform: uppercase;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  span {
    background: #ffb000;
    border-radius: 50%;
    height: 30px;
    width: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    animation: ${(p) => (p.aboveAnim ? btnRotateAnim : null)};
    animation-duration: 0.5s;
    animation-fill-mode: forwards;
  }
`;
export const Title = styled.div`
  line-height: 1.4;
  margin-bottom: 25px;
  font-size: 18px;
  h4 {
    text-transform: none;
  }
  p {
    font-family: "GT America, regular";
    width: 100%;
    overflow-x: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
  }
  textarea {
    text-transform: none;

    font-family: "GT America, regular";
    background: transparent;
    border: none;
    outline: none;
    color: transparent;
    text-shadow: 0 0 0 #ffb000;
    font-size: 18px;
    margin: auto;
    appearance: none;
    cursor: ${(p) => (p.copyCursor ? "auto" : "copy")};
    width: 100%;
    max-width: 500px;
    resize: none;
    user-select: text !important;
    line-height: 1.4;
    font-weight: 300;
    scrollbar-width: none;
    :focus {
      outline-offset: 10px;
      outline: none;
      border: none;
      outline: 0;
    }
    ::selection {
      background: none;
      border: none;
      text-decoration-line: underline;
      :-moz-focus-inner {
        border: none;
        outline: none;
      }
    }

    /* @media only screen and (min-width: 375px) {
    font-size: 20px;
  } */
  }
`;
export const Button = styled.div`
  background: #ffb000;
  border: solid 3px #ffb000;
  border-radius: 38px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  /* color: #4199ba; */
  color: #7f3da5;
  text-transform: none;

  font-size: 18px;
  margin: 20px 0;
  position: relative;
  cursor: pointer;
  &&.disabled {
    pointer-events: none;
    opacity: 0.6;
  }
  :after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    transform: scale(1);
    background: #ffffff;
    border: solid 3px #ffffff;
    border-radius: 38px;
    opacity: 0;
    animation: ${(p) => (p.setA ? btnBackgroundAnim : null)};
    animation-duration: 0.5s;
  }
  animation: ${(p) => (p.setA ? btnScaleAnim : null)};
  animation-duration: 0.5s;
  ${(props) =>
    props.isClickable === false || props.isAutoOn
      ? "pointer-events: none"
      : "pointer-events: auto"}/* @media only screen and (min-width: 375px) {
    height: 56px;
    font-size: 20px;
  } */
`;

export const SeedInput = styled.input`
  font-family: "GT America, regular";
  background: transparent;
  border: solid 3px;
  border-radius: 38px;
  height: 48px;
  display: flex;
  text-transform: none;
  align-items: center;
  justify-content: center;
  width: 100%;
  font-size: 18px;
  padding: 0 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: all 0.5s;
  ${(props) =>
    props.notify && (props.clickable === true || props.autoOn === false)
      ? // ? "color: #ff3920; border-color: #ff3920;"
        "color: #ff3920; border-color: #ff3920;"
      : "color: #ffb000; border-color: #ffb000;"}
  ${(props) =>
    props.clickable || props.autoOn
      ? "pointer-events: none; color: #ffb000; border-color: #ffb000;"
      : "pointer-events: auto"}
  &::placeholder {
    color: #ffb000;
  }
  outline: none;
  /* @media only screen and (min-width: 375px) {
    height: 56px;
    font-size: 20px;
  } */
`;

export const Description = styled.div`
  font-size: 20px;
  margin-bottom: 30px;
  line-height: 1.33;
  h3 {
    text-transform: none;
    margin-bottom: 13px;
  }
  h4 {
    text-transform: none;

    font-size: 16px;
  }
  p {
    text-transform: none;

    font-size: 16px;
    font-family: "GT America, regular";
  }
  @media only screen and (min-width: 375px) {
    font-size: 26px;
    h4 {
      font-size: 20px;
    }
    p {
      font-size: 20px;
    }
  }
`;
export const DetailedContainer = styled.div`
  border-radius: 18px;
  border: solid 3px #233b50;
  /* width: 260px; */
  margin: auto auto 30px;
  /* @media only screen and (min-width: 375px) {
    width: 315px;
  } */
`;
export const DetailedDescription = styled.div`
  padding: 14px 20px;
  h4 {
    font-size: 16px;
    text-transform: uppercase;
    margin-bottom: 10px;
  }
  p {
    text-transform: none;

    font-size: 10px;
  }
  /* @media only screen and (min-width: 375px) {
    h4 {
      font-size: 20px;
    }
    p {
      font-size: 12px;
    }
  } */
`;
export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  text-align: center;
  h4 {
    width: 50%;
    text-align: center;
    padding: 10px;
    border-top: solid 3px #233b50;
    border-bottom: solid 3px #233b50;
    text-transform: uppercase;
    :first-child {
      border-right: solid 3px #233b50;
    }
  }
`;
export const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 50%;
  align-items: center;
  min-height: 188px;
  border-bottom: solid 3px #233b50;
  &&.centered {
    justify-content: center;
  }
  &&.border-b {
    border-bottom: none;
  }
  :first-child {
    border-right: solid 3px #233b50;
  }
`;
export const Box = styled.div`
  padding: 10px 0;
  border: solid 3px #ffb000;
  width: 120px;
  font-size: 10px;
  margin: 10px auto;
  text-transform: uppercase;
  position: relative;
  &&.round {
    border-radius: 23px;
  }
  svg {
    transform: translateY(1px) translateX(3px);
  }
  /* @media only screen and (min-width: 375px) {
    width: 120px;
    font-size: 12px;
  } */
`;
export const Romb = styled.div`
  background: url(${RombSVG});
  font-size: 10px;
  position: relative;
  border: 3px solid rgb(255, 176, 0);
  width: 120px;
  height: 36px;
  margin: 10px auto;
  text-transform: uppercase;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Circle = styled.div`
  width: 9px;
  height: 9px;
  border-radius: 50%;
  position: absolute;
  /* background: #4199ba; */
  background: #7f3da5;
  border: solid 1px #ffb000;
  z-index: 2;
  right: -5px;
  bottom: 50%;
  transform: translateY(50%);
  box-shadow: 0px 0px 0px 2px #ffb000;
  &&.left {
    right: unset;
    left: -5px;
  }
  &&.top {
    bottom: unset;
    top: -5px;
    right: 50%;
    transform: translateY(0) translateX(50%);
  }
  &&.bottom {
    bottom: -5px;
    right: 50%;
    transform: translateY(0) translateX(50%);
  }
  &&.rightCorner {
    bottom: -5px;
    right: -5px;
    transform: translateY(0);
  }
  &&.leftCorner {
    bottom: unset;
    top: -5px;
    left: -5px;
    transform: translateY(0);
  }
  &&.rightRomb {
    /* right: 5px; */
  }
  &&.leftRomb {
    /* right: unset; */
    left: -5px;
  }
`;
export const Line = styled.div`
  height: 3px;
  width: 30px;
  position: absolute;
  z-index: 1;
  background: #ffb000;
  right: -38px;
  bottom: 50%;
  transform: translateY(50%);
  /* @media only screen and (min-width: 375px) {
    right: -50px;
    width: 60px;
  } */
  &&.down {
    height: 35px;
    width: 3px;
    right: 50%;
    bottom: -35px;
    transform: translateY(0) translateX(50%);
  }
  &&.diagTop {
    width: 75px;
    right: -75px;
    bottom: 50%;
    transform: translateY(0) translateX(0) rotate(-61deg);
    transform-origin: left;
    @media only screen and (min-width: 375px) {
      width: 80px;
      right: -80px;
      transform: translateY(0) translateX(0) rotate(-57deg);
    }
  }
  &&.diagBot {
    width: 75px;
    right: -75px;
    bottom: 50%;
    transform: translateY(0) translateX(0) rotate(61deg);
    transform-origin: left;
    @media only screen and (min-width: 375px) {
      width: 80px;
      right: -80px;
      transform: translateY(0) translateX(0) rotate(57deg);
    }
  }
  &&.diagBotLong {
    width: 100px;
    right: -100px;
    transform: translateY(0) translateX(0) rotate(71deg);
    bottom: 0;
    transform-origin: left;
    @media only screen and (min-width: 375px) {
      transform: translateY(0) translateX(0) rotate(66deg);
    }
  }
`;

// import styled from "styled-components";

// export const ProvFairDiv = styled.div`
//   position: absolute;
//   top: 0;
//   left: 0;
//   /* transform: scale(1.1); */

//   background: #7f3da5;
//   width: 100%;
//   height: 100%;
//   overflow-y: scroll;
//   ::-webkit-scrollbar {
//     display: none;
//   }
//   opacity: 0.85;
//   color: #ffb000;
//   padding: 20px 8% 8%;
// `;
// export const Header = styled.div`
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   padding: 0 0 30px;
//   max-width: 320px;
//   margin: auto;
//   p {
//     font-size: 26px;
//   }
//   svg {
//     background: #ffb000;
//     padding: 10px;
//     border-radius: 50%;
//   }
// `;
// export const Body = styled.div`
//   max-width: 320px;
//   margin: auto;
// `;
// export const Seed = styled.div`
//   padding: 0% 0% 8.8%;
//   h1 {
//     font-size: 20px;
//     text-transform: none;
//     line-height: 1.8;
//   }
//   p {
//     text-transform: none;
//     font-size: 20px;
//     font-family: "GT America, regular";
//     word-wrap: break-word;
//     line-height: 1.3;
//   }
// `;
// export const Buttons = styled.div`
//   text-align: center;
// `;
// export const NewSeed = styled.input`
//   font-size: 20px;
//   line-height: 1.8;
//   font-family: "GT America, regular";
//   font-weight: 300;
//   color: #ffb000;
//   text-transform: none;
//    : none;
//   border-radius: 30px;
//   border: solid 3px #ffb000;
//   background: none;
//   padding: 5px 22.4px 9px 22.4px;
//   width: 100%;
//   &::placeholder {
//     color: #ffb000;
//   }
// `;
// export const Set = styled.div`
//   color: #6a268a;
//   font-size: 20px;
//   border-radius: 30px;
//   background: #ffb000;
//   text-align: center;
//   padding: 15px 0 17px 0;
//   width: 100%;
//   margin: 3.12% auto 0%;
// `;
// export const DescriptionBox = styled.div`
//   max-width: 320px;
//   margin: auto;
// `;
// export const Title = styled.div`
//   font-size: 26px;
//   padding: 11.84% 0% 4.05%;
// `;
// export const SubTitle = styled.div`
//   font-size: 20px;
//   padding: 3.74% 0 0.625%;
//   line-height: 1.8;
// `;
// export const Description = styled.div`
//   font-weight: 300;
//   font-family: "GT America, regular";
//   text-transform: none;
//   font-size: 20px;
// `;

// // detailed prov. fair

// export const DetailedContainer = styled.div`
//   border: solid 3px #32075b;
//   border-radius: 18px;
//   max-width: 320px;
//   margin: 30px auto;
//   .BorderR {
//     border-right: solid 3px #32075b;
//   }
//   .BorderNone {
//     border-bottom: none;
//   }
//   .Centered {
//     justify-content: center;
//     height: 186px;
//   }
//   .RhombL {
//     left: -20px;
//   }
//   .RhombR {
//     right: -20px;
//   }
//   @media only screen and (max-width: 374px) {
//     width: 268px;
//   }
// `;

// export const DetailedBoxWrapper = styled.div`
//   display: flex;
//   text-align: center;
//   justify-content: center;
//   border-bottom: solid 3px #32075b;
//   border-top: solid 3px #32075b;
// `;

// export const DetailedColumn = styled.div`
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
//   width: 50%;
// `;
// export const DetailedBox = styled.div`
//   height: 100%;
//   justify-content: space-between;
//   display: flex;
//   flex-direction: column;
// `;

// export const DetailedHeader = styled.div`
//   font-size: 20px;
//   color: #ffb000;
//   font-family: "GT America, regular";
//   font-weight: bold;
//   padding-bottom: 10px;
//   padding: 5.6%;
// `;

// export const DetailedDescription = styled.div`
//   font-size: 12px;
//   color: #ffb000;
//   font-family: "GT America, regular";
//   font-weight: bold;
//   text-transform: none;
//   padding: 0 5.6% 5.6%;
// `;

// export const DetailedTitle = styled.div`
//   font-size: 12px;
//   color: #ffb000;
//   font-family: "GT America, bold";
//   border-bottom: solid 3px #32075b;
//   padding: 10px 0 12px;
// `;

// export const DetailedRectBox = styled.div`
//   border: solid 3px #ffb000;
//   font-size: 12px;
//   padding: 11px 0;
//   width: 90%;
//   max-width: 120px;
//   margin: 10px auto;
//   position: relative;
// `;

// export const DetailedOvalBox = styled.div`
//   border: solid 3px #ffb000;
//   font-size: 12px;
//   padding: 11px 0;
//   width: 90%;
//   max-width: 120px;
//   border-radius: 23px;
//   margin: 10px auto;
//   position: relative;
// `;

// export const DetailedRhombBox = styled.div`
//   font-size: 12px;
//   padding: 11px 0;
//   width: 82px;
//   max-width: 120px;
//   margin: 10px auto;
//   position: relative;
//   z-index: 2;
//   border-top: solid 3px #ffb000;
//   border-bottom: solid 3px #ffb000;
//   :before {
//     content: "";
//     z-index: -1;
//     left: -15px;
//     position: absolute;
//     border: solid #ffb000;
//     border-width: 0 3px 3px 0;
//     display: inline-block;
//     padding: 13.5px;
//     transform: rotate(135deg);
//     top: 3px;
//   }
//   :after {
//     content: "";
//     z-index: -1;
//     right: -15px;
//     position: absolute;
//     border: solid #ffb000;
//     border-width: 0 3px 3px 0;
//     display: inline-block;
//     padding: 13.5px;
//     transform: rotate(-45deg);
//     top: 3px;
//   }
// `;

// export const DetailedSVGBox = styled.div``;

// export const DetailedCircleR = styled.div`
//   width: 9px;
//   height: 9px;
//   background: #7f3da5;
//   border-radius: 50%;
//   border: solid 1px #ffb000;
//   position: absolute;
//   z-index: 2;
//   right: -5px;
//   bottom: 50%;
//   -webkit-transform: translateY(50%);
//   -ms-transform: translateY(50%);
//   transform: translateY(50%);
//   box-shadow: 0px 0px 0px 2px #ffb000;
// `;
// export const DetailedCircleL = styled.div`
//   width: 9px;
//   height: 9px;
//   background: #7f3da5;
//   border-radius: 50%;
//   border: solid 1px #ffb000;
//   position: absolute;
//   z-index: 2;
//   left: -5px;
//   bottom: 50%;
//   -webkit-transform: translateY(50%);
//   -ms-transform: translateY(50%);
//   transform: translateY(50%);
//   box-shadow: 0px 0px 0px 2px #ffb000;
// `;
// export const DetailedCircleT = styled.div`
//   width: 9px;
//   height: 9px;
//   background: #7f3da5;
//   border-radius: 50%;
//   border: solid 1px #ffb000;
//   position: absolute;
//   z-index: 2;
//   right: 50%;
//   top: -5px;
//   -webkit-transform: translateX(50%);
//   -ms-transform: translateX(50%);
//   transform: translateX(50%);
//   box-shadow: 0px 0px 0px 2px #ffb000;
// `;
// export const DetailedCircleB = styled.div`
//   width: 9px;
//   height: 9px;
//   background: #7f3da5;
//   border-radius: 50%;
//   border: solid 1px #ffb000;
//   position: absolute;
//   z-index: 2;
//   right: 50%;
//   bottom: -5px;
//   -webkit-transform: translateX(50%);
//   -ms-transform: translateX(50%);
//   transform: translateX(50%);
//   box-shadow: 0px 0px 0px 2px #ffb000;
// `;
// export const DetailedCircleBC = styled.div`
//   width: 9px;
//   height: 9px;
//   background: #7f3da5;
//   border-radius: 50%;
//   border: solid 1px #ffb000;
//   position: absolute;
//   z-index: 2;
//   right: -5px;
//   bottom: -5px;
//   box-shadow: 0px 0px 0px 2px #ffb000;
// `;
// export const DetailedCircleTC = styled.div`
//   width: 9px;
//   height: 9px;
//   background: #7f3da5;
//   border-radius: 50%;
//   border: solid 1px #ffb000;
//   position: absolute;
//   z-index: 2;
//   left: -5px;
//   top: -5px;
//   box-shadow: 0px 0px 0px 2px #ffb000;
// `;
// export const LineDownD = styled.div`
//   width: 70px;
//   height: 3px;
//   background: #ffb000;
//   transform: rotate(58deg) translateY(3px);
//   -webkit-transform: rotate(58deg) translateY(3px);
//   -ms-transform: rotate(58deg) translateY(3px);
//   -ms-transform-origin: bottom;
//   transform-origin: left bottom;
//   position: absolute;
//   right: -74px;
//   z-index: 1;
//   bottom: 50%;
//   @media only screen and (max-width: 374px) {
//     transform: rotate(73deg) translateY(3px);
//     -webkit-transform: rotate(73deg) translateY(3px);
//     -ms-transform: rotate(73deg) translateY(3px);
//   }
// `;
// export const LineUpD = styled.div`
//   width: 70px;
//   height: 3px;
//   background: #ffb000;
//   transform: rotate(-58deg) translateY(3px);
//   -webkit-transform: rotate(-58deg) translateY(3px);
//   -ms-transform: rotate(-58deg) translateY(3px);
//   -ms-transform-origin: bottom;
//   transform-origin: left bottom;
//   position: absolute;
//   right: -74px;
//   z-index: 1;
//   bottom: 50%;
//   @media only screen and (max-width: 374px) {
//     transform: rotate(-73deg) translateY(-1px);
//     -webkit-transform: rotate(-73deg) translateY(-1px);
//     -ms-transform: rotate(-73deg) translateY(-1px);
//   }
// `;
// export const LineV = styled.div`
//   width: 3px;
//   height: 20px;
//   background: #ffb000;
//   transform: translateX(50%);
//   position: absolute;
//   right: 50%;
//   z-index: 1;
//   bottom: -20px;
// `;
// export const LineH = styled.div`
//   width: 40px;
//   height: 3px;
//   background: #ffb000;
//   transform: translateY(50%);
//   position: absolute;
//   right: -55px;
//   z-index: 1;
//   bottom: 50%;
//   @media only screen and (max-width: 374px) {
//     width: 20px;
//     right: -35px;
//   }
// `;
// export const LineD = styled.div`
//   width: 90px;
//   height: 3px;
//   background: #ffb000;
//   transform: rotate(65deg) translateY(4px);
//   -webkit-transform: rotate(65deg) translateY(4px);
//   -ms-transform: rotate(65deg) translateY(4px);
//   -ms-transform-origin: bottom;
//   -webkit-transform-origin: left bottom;
//   -ms-transform-origin: left bottom;
//   transform-origin: left bottom;
//   position: absolute;
//   right: -94px;
//   z-index: 1;
//   bottom: 0;
//   @media only screen and (max-width: 374px) {
//     transform: rotate(78deg) translateY(4px);
//     -webkit-transform: rotate(78deg) translateY(4px);
//     -ms-transform: rotate(78deg) translateY(4px);
//   }
// `;
